import React from 'react';
import { REGRAS_SENHA } from '../utils/senhaPolitica';

// Lista dos requisitos da senha que vai ficando verde enquanto a pessoa digita
export default function RequisitosSenha({ senha = '', confirmacao }) {
  const itens = [
    ...REGRAS_SENHA.map(r => ({ id: r.id, texto: r.texto, ok: r.ok(senha) })),
    { id: 'parecida', texto: 'Diferente das senhas anteriores (não vale só trocar números/símbolos)', info: true },
  ];
  if (confirmacao !== undefined) itens.push({ id: 'iguais', texto: 'As duas senhas iguais', ok: !!senha && senha === confirmacao });
  return (
    <ul style={{ listStyle: 'none', margin: '0 0 20px', padding: '10px 14px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, fontSize: '0.82rem' }}>
      {itens.map(i => (
        <li key={i.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '2px 0', color: i.info ? '#64748b' : (i.ok ? '#15803d' : '#94a3b8') }}>
          <span style={{ width: 16, flexShrink: 0, fontWeight: 700 }}>{i.info ? 'ℹ' : (i.ok ? '✓' : '○')}</span>
          <span>{i.texto}</span>
        </li>
      ))}
    </ul>
  );
}
